export const HYDRATING = "⏳ Hydrating";
export const HYDRATED = "⌛️ Hydrated";
export const HYDRATION_FAILED = "🔴 Hydration Failed";
export const SET_USER = "😎 Set User";
export const SET_APP = "🤖 Set App";
